/** Firebase Remote Config parameter keys (client + server). */
export const REMOTE_CONFIG_KEYS = {
  minAppVersion: 'min_app_version',
  devPanel: 'feature_dev_panel',
  phoneAuth: 'feature_phone_auth',
  aiAssist: 'feature_ai_assist',
  rag: 'feature_rag',
  liveSupport: 'feature_live_support',
  auditExport: 'feature_audit_export',
  cutoffWarningMinutes: 'cutoff_warning_minutes',
  maintenanceMode: 'maintenance_mode',
  ragTopK: 'rag_top_k',
  ragMinScore: 'rag_min_score',
} as const;

export type RemoteConfigKey = typeof REMOTE_CONFIG_KEYS[keyof typeof REMOTE_CONFIG_KEYS];

export interface RemoteConfigFlags {
  minAppVersion: string;
  devPanel: boolean;
  phoneAuth: boolean;
  aiAssist: boolean;
  rag: boolean;
  liveSupport: boolean;
  auditExport: boolean;
  cutoffWarningMinutes: number;
  maintenanceMode: boolean;
  ragTopK: number;
  ragMinScore: number;
}
